import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const IconMuiV2 = styled.div<{ color?: string }>`
  font-family: 'Material Icons', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: ${({ color }) => (color ? color : COLORS.black)};
`;
